export default "__VITE_ASSET__zhIa5pgF__"